(function() {

    var expireDateTime,
        configHeartBeatDelay = 15000,
        lastTrackerRequestTime = null,
        isPageUnloading = false,
        heartBeatSetUp = false,
        timeWindowLastFocussed = null,
        configVisitStandardLength = 1800,
        configTrackerPause = 500,
        browserFeatures = [];
    
    trackCallbackOnLoad(function() {
        trackRequest('i', null);
    });
    
    function heartBeatPingIfActivity(){
    
        var now = new Date();
        now = now.getTime();
    
        if (!lastTrackerRequestTime) {
            return false; // no tracking request was ever sent so lets not send heartbeat now
        }
        if ((lastTrackerRequestTime + (1000*configVisitStandardLength)) <= now) {
            // heart beat does not extend the visit length and therefore there is pretty much no point
            // to send requests after this
            return false;
        }
    
        if (lastTrackerRequestTime + configHeartBeatDelay <= now) {
            trackRequest('p', null);
    
            return true;
        }
    
        return false;
    }
    
    function beforeUnloadHandler() {
        var now;
        isPageUnloading = true;
    
        if (heartBeatSetUp && hadWindowMinimalFocusToConsiderViewed()) {
            heartBeatPingIfActivity();
        }
        
        /*
            * Delay/pause (blocks UI)
            */
        if (expireDateTime) {
            // the things we do for backwards compatibility...
            // in ECMA-262 5th ed., we could simply use:
            //     while (Date.now() < expireDateTime) { }
            do {
                now = new Date();
            } while (now.getTime() < expireDateTime);
        }
    }
    
    function setExpireDateTime(delay) {
    
        var now  = new Date();
        var time = now.getTime() + delay;
    
        if (!expireDateTime || time > expireDateTime) {
            expireDateTime = time;
        }
    }
    
    function hadWindowMinimalFocusToConsiderViewed() {
        // we ping on blur or unload only if user was active for more than configHeartBeatDelay seconds on
        // the page otherwise we can assume user was not really on the page and for example only switching
        // through tabs
        var now = new Date().getTime();
        return !timeWindowLastFocussed || (now - timeWindowLastFocussed) > configHeartBeatDelay;
    }
    
    function heartBeatOnFocus() {
        timeWindowLastFocussed = new Date().getTime();
    }
    
    function heartBeatOnBlur() {
        if (hadWindowMinimalFocusToConsiderViewed()) {
            heartBeatPingIfActivity();
        }
    }
    
    function setUpHeartBeat() {
        if (heartBeatSetUp) {
            return;
        }
    
        heartBeatSetUp = true;
    
        window.addEventListener('focus', heartBeatOnFocus);
        window.addEventListener('blur', heartBeatOnBlur);
        window.addEventListener('beforeunload', beforeUnloadHandler, false);
        
    }
    
    function detectBrowserFeatures() {
        if (browserFeatures.length) {
            return browserFeatures;
        }
        var i,
            mimeType,
            pluginMap = {
                // document types
                pdf: 'application/pdf',
    
                // media players
                qt: 'video/quicktime',
                realp: 'audio/x-pn-realaudio-plugin',
                wma: 'application/x-mplayer2',
    
                // interactive multimedia
                dir: 'application/x-director',
                fla: 'application/x-shockwave-flash',
    
                // RIA
                java: 'application/x-java-vm',
                gears: 'application/x-googlegears',
                ag: 'application/x-silverlight'
            };
    
        // detect browser features except IE < 11 (IE 11 user agent is no longer MSIE)
        if (!((new RegExp('MSIE')).test(navigator.userAgent))) {
            // general plugin detection
            for (i in pluginMap) {
                var res = '0';
                if (navigator.mimeTypes && navigator.mimeTypes.length) {
                    if (Object.prototype.hasOwnProperty.call(pluginMap, i)) {
                        mimeType = navigator.mimeTypes[pluginMap[i]];
                        if (mimeType && mimeType.enabledPlugin) {
                            res = '1';
                        }
                    }
                }
                browserFeatures.push(res);
            }
    
            // Safari and Opera
            // IE6/IE7 navigator.javaEnabled can't be aliased, so test directly
            // on Edge navigator.javaEnabled() always returns `true`, so ignore it
            var java = '0';
            if (!((new RegExp('Edge[ /](\\d+[\\.\\d]+)')).test(navigator.userAgent)) &&
                typeof navigator.javaEnabled !== 'unknown' &&
                typeof navigator.javaEnabled !== 'undefined' &&
                navigator.javaEnabled()) {
                java = '1';
            }
            browserFeatures.push(java);
    
            // Firefox
            var gears = '0';
            if (typeof window.GearsFactory !== 'undefined') {
                gears = '1';
            }
            browserFeatures.push(gears);
    
            // other browser features
            browserFeatures.push( hasCookies() );
        } else {
            browserFeatures = [0,0,0,0,0,0,0,0,0,0,0,0];
        }
    
        var width = parseInt(screen.width, 10);
        browserFeatures.push(parseInt(width, 10));

        var height = parseInt(screen.height, 10);
        browserFeatures.push(parseInt(height, 10));

        return browserFeatures;
    }
    
    function trackCallback(callback) {
    
       function prefixPropertyName(prefix, propertyName) {
            if (prefix !== '') {
                return prefix + propertyName.charAt(0).toUpperCase() + propertyName.slice(1);
            }
    
            return propertyName;
        }
    
        var isPreRendered,
            i,
            // Chrome 13, IE10, FF10
            prefixes = ['', 'webkit', 'ms', 'moz'],
            prefix;
    
        for (i = 0; i < prefixes.length; i++) {
            prefix = prefixes[i];
    
            // does this browser support the page visibility API?
            if (Object.prototype.hasOwnProperty.call(document, prefixPropertyName(prefix, 'hidden'))) {
                // if pre-rendered, then defer callback until page visibility changes
                if (document[prefixPropertyName(prefix, 'visibilityState')] === 'prerender') {
                    isPreRendered = true;
                }
                break;
            }
        }
    
        if (isPreRendered) {
            // note: the event name doesn't follow the same naming convention as vendor properties
            document.document.addEventListener(prefix + 'visibilitychange', function ready() {
                document.removeEventListener(prefix + 'visibilitychange', ready, false);
                callback();
            });
    
            return;
        }
    
        // configCountPreRendered === true || isPreRendered === false
        callback();
    }
    
    function sendRequest(request, callback) {
    
        var now     = new Date();
        var timeNow = now.getTime();
    
        lastTrackerRequestTime = timeNow;
    
        var browserFeatures = detectBrowserFeatures();
        // browser features
        for (i in browserFeatures) {
            request.push(browserFeatures[i]);
        }
    
        request.push(now.getHours());
        request.push(now.getMinutes());
        request.push(now.getSeconds());

        sendPostRequestViaSendBeacon(request, callback);
    
        setExpireDateTime(configTrackerPause);
    
        if (!heartBeatSetUp) {
            setUpHeartBeat(); // setup window events too, but only once
        }
    }

    function trackRequest(request, callback) {
        trackCallback(function () {
            sendRequest([request], callback);
        });
    };
    
    function trackCallbackOnLoad(callback)
    {
        if (document.readyState === 'complete') {
            callback();
        } else {
            window.addEventListener('load', callback, false);
        }
    }
    
    function sendPostRequestViaSendBeacon(request, callback)
    {
        var isSupported = 'object' === typeof navigator
                        && 'function' === typeof navigator.sendBeacon
                        && 'function' === typeof Blob;
    
        if (!isSupported) {
            return false;
        }
    
        var headers = {type: 'application/x-www-form-urlencoded; charset=UTF-8'};
        var success = false;

        try {
            var blob = new Blob([], headers);
    
            success = navigator.sendBeacon('/cgcplkayevcl/?wbwal=' + request.join('-'), blob);
            // returns true if the user agent is able to successfully queue the data for transfer,
            // Otherwise it returns false and we need to try the regular way
    
        } catch (e) {
            return false;
        }
    
        if (success && typeof callback === 'function') {
            callback({success: true});
        }
    
        return success;
    }
        /*
        * Set cookie value
        */
    function setCookie(cookieName, value, msToExpire, path, domain, isSecure) {

        var expiryDate;

        // relative time to expire in milliseconds
        if (msToExpire) {
            expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + msToExpire);
        }

        document.cookie = cookieName + '=' + encodeWrapper(value) +
            (msToExpire ? ';expires=' + expiryDate.toGMTString() : '') +
            ';path=' + (path || '/') +
            (domain ? ';domain=' + domain : '') +
            (isSecure ? ';secure' : '') +
            ';SameSite=Lax';
    }

    /*
        * Get cookie value
        */
    function getCookie(cookieName) {

        var cookiePattern = new RegExp('(^|;)[ ]*' + cookieName + '=([^;]*)'),
            cookieMatch = cookiePattern.exec(document.cookie);

        return cookieMatch ? decodeWrapper(cookieMatch[2]) : 0;
    }

        /*
        * Does browser have cookies enabled (for this site)?
        */
    function hasCookies() {

        if(typeof window.showModalDialog === 'undefined' && typeof navigator.cookieEnabled !== 'undefined') {
            return navigator.cookieEnabled ? '1' : '0';
        }

        // for IE we want to actually set the cookie to avoid trigger a warning eg in IE see #11507
        var testCookieName = 'testcookie';
        setCookie(testCookieName, '1', undefined, undefined, undefined, undefined);

        var hasCookie = getCookie(testCookieName) === '1' ? '1' : '0';
        deleteCookie(testCookieName);
        return hasCookie;
    }
    
    function deleteCookie(cookieName, path, domain) {
        setCookie(cookieName, '', -86400, path, domain);
    }
})();